import { Typography } from '@mui/material';
import { translateFunc } from '../../../Helpers/translateFunc';

export const AttributePlain = ({ data, tt }) => {

 return (
    <>
        <Typography color='primary.main' variant='h3'>
            {translateFunc(
                tt, 
                `basicFormStepByStep.placeholdersTranslate.${data.label}`,
                data.label
            )}
        </Typography>
        <Typography color='text.primary' variant='subtitle1'>
            {
                data.value
            }
        </Typography>
    </>
 );
};
